const BorderRadiusSvg = () => (
  <svg
    fill="currentColor"
    height="512"
    viewBox="0 0 24 24"
    width="512"
    xmlns="http://www.w3.org/2000/svg"
    id="fi_8912084"
  >
    <g clipRule="evenodd" fill="rgb(0,0,0)" fillRule="evenodd">
      <path d="m8 5c-.79565 0-1.5587.31607-2.12132.87867 0 0-.00001.00001-.00001.00001m0 0c-.5626.56262-.87867 1.32567-.87867 2.12132v4c0 .5523-.44772 1-1 1s-1-.4477-1-1v-4c0-1.32609.52679-2.59785 1.46446-3.53553l.00001-.00001c.93768-.93767 2.20944-1.46446 3.53553-1.46446h4c.5523 0 1 .44772 1 1s-.4477 1-1 1h-4"></path>
      <path d="m16 3c.5523 0 1 .44772 1 1v.01c0 .55229-.4477 1-1 1s-1-.44771-1-1v-.01c0-.55228.4477-1 1-1z"></path>
      <path d="m20 3c.5523 0 1 .44772 1 1v.01c0 .55229-.4477 1-1 1s-1-.44771-1-1v-.01c0-.55228.4477-1 1-1z"></path>
      <path d="m20 7c.5523 0 1 .44772 1 1v.01c0 .55229-.4477 1-1 1s-1-.44771-1-1v-.01c0-.55228.4477-1 1-1z"></path>
      <path d="m20 11c.5523 0 1 .4477 1 1v.01c0 .5523-.4477 1-1 1s-1-.4477-1-1v-.01c0-.5523.4477-1 1-1z"></path>
      <path d="m4 15c.55228 0 1 .4477 1 1v.01c0 .5523-.44772 1-1 1s-1-.4477-1-1v-.01c0-.5523.44772-1 1-1z"></path>
      <path d="m20 15c.5523 0 1 .4477 1 1v.01c0 .5523-.4477 1-1 1s-1-.4477-1-1v-.01c0-.5523.4477-1 1-1z"></path>
      <path d="m4 19c.55228 0 1 .4477 1 1v.01c0 .5523-.44772 1-1 1s-1-.4477-1-1v-.01c0-.5523.44772-1 1-1z"></path>
      <path d="m8 19c.55228 0 1 .4477 1 1v.01c0 .5523-.44772 1-1 1s-1-.4477-1-1v-.01c0-.5523.44772-1 1-1z"></path>
      <path d="m12 19c.5523 0 1 .4477 1 1v.01c0 .5523-.4477 1-1 1s-1-.4477-1-1v-.01c0-.5523.4477-1 1-1z"></path>
      <path d="m16 19c.5523 0 1 .4477 1 1v.01c0 .5523-.4477 1-1 1s-1-.4477-1-1v-.01c0-.5523.4477-1 1-1z"></path>
      <path d="m20 19c.5523 0 1 .4477 1 1v.01c0 .5523-.4477 1-1 1s-1-.4477-1-1v-.01c0-.5523.4477-1 1-1z"></path>
    </g>
  </svg>
);

export default BorderRadiusSvg;
